import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { FacetId } from '../../../types.js';
import CurrentRefinements from '../CurrentRefinements/CurrentRefinements.js';
import ConnectedFacetInputList from '../FacetInputList/ConnectedFacetInputList.js';
import ConnectedFacetInputPriceRange from '../FacetInputPriceRange/ConnectedFacetInputPriceRange.js';

const FacetsDesktop = ({ facets  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "facets-desktop"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "facets-desktop__top-bar",
        role: "toolbar",
        tabIndex: 0,
        "aria-labelledby": "filters",
        "data-t": "facets-desktop-list"
    }, /*#__PURE__*/ React.createElement("h2", {
        id: "filters",
        className: "sr-only"
    }, getLabel('products.filters')), facets.map((facet)=>/*#__PURE__*/ React.createElement(FacetComponent, {
            key: facet.id,
            facet: facet
        })
    )), /*#__PURE__*/ React.createElement("div", {
        className: "facets-desktop__refinements"
    }, /*#__PURE__*/ React.createElement(CurrentRefinements, null)));
};
const FacetComponent = ({ facet  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, facet.id === FacetId.price ? /*#__PURE__*/ React.createElement(ConnectedFacetInputPriceRange, {
        key: facet.attribute,
        facet: facet,
        attribute: facet.attribute
    }) : /*#__PURE__*/ React.createElement(ConnectedFacetInputList, {
        key: facet.attribute,
        facet: facet,
        attribute: facet.attribute,
        searchable: facet.searchable,
        limit: 100
    }))
;

export { FacetComponent, FacetsDesktop as default };
//# sourceMappingURL=FacetsDesktop.js.map
